import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { ORDER_CACHE_KEYS } from "./keys";

import { OrderRepository } from "@/repositories/order";

export const useAttributionOptions = () => {
  const orderRepository = useRef(new OrderRepository());

  return useQuery({
    queryKey: ORDER_CACHE_KEYS.ATTRIBUTION_OPTIONS,
    queryFn: () => orderRepository.current.attributionOptions(),
    staleTime: 5 * 60 * 1000,
  });
};
